import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: 'enroll'
    },
    {
      path: '/enroll',
      name: 'enroll',
      component: () => import(/* webpackChunkName: "enroll" */ './views/EnrollAuthenticator.vue')
    },
    {
      path: '/reminder',
      name: 'reminder',
      component: () => import(/* webpackChunkName: "reminder" */ './views/Reminder.vue')
    },
    { path: '*', redirect: '/enroll' }
  ]
})
